import { useQuery } from '@tanstack/react-query';

import { getExternalApiKeys } from '../data-access/getExternalApiKeys';

export const useExternalApiKeys = () =>
  useQuery({
    queryKey: ['external-api-keys'],
    queryFn: () => getExternalApiKeys(),
  });
